export interface GemeenteModel {
  id: string;
  naam: string;
  provincie: string;
  geometry: string;
}
